import { useState } from 'react';

import TrainingDivisionScreen from './TrainingDivisionScreen';

import { Container, Wrapper } from './styles';

type Props = {
  refreshProgram: () => Promise<void>;
};

export default function Basic({ refreshProgram }: Props) {
  const [_, setLockNextScreen] = useState(true);

  function lockScreen(value: boolean) {
    setLockNextScreen(value);
  }

  return (
    <Container>
      <Wrapper>
        <TrainingDivisionScreen
          lockScreen={lockScreen}
          refreshProgram={refreshProgram}
        />
      </Wrapper>
    </Container>
  );
}
